import { useAdministrativeContext } from "../../../../../pages/administrativePanel/administrativePanelContext";
import { useState, useEffect, createContext,useCallback } from "react";
import { toast } from "react-toastify";
import { api } from "../../../../../services/api";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

export const MetasContext = createContext();

export function GoalsProvider({ children }) {
    const openModalForms = useSelector(state => state.modalForms);
    const dispatch = useDispatch()

    const {
        startDate,
        endDate,
        listBusinessToFilter,
        setListBusinessToFilter
    } = useAdministrativeContext();
    const [goals, setGoals] = useState([]);
    const [loading, setLoading] = useState(true);

    const [search, setSearch] = useState('');
    const [idBusiness, setIdBusiness] = useState('');
    const [dateGoal, setDateGoal] = useState('');
    const [valueGoal, setValueGoal] = useState('');
    const [valueBalancePoint, setValueBalancePoint] = useState('');
    const [idMeta, setIdMeta] = useState('');
    const [page,setPage] = useState(1);
    const [loadingButton,setLoadingButton] = useState(false);

    const handleNewGoals = useCallback( async () => {
        setLoadingButton(true);

        try{
            const response = await api.post(`/getCompanyGoals/?page=${page}`,
            {
                business: listBusinessToFilter,
                endDate: endDate,
                startDate: startDate,
            },
            {
                headers: {
                    token: localStorage.getItem('@Inoveclube:token')
                }
            }
            )
            setGoals([...goals,...response.data.goals])
            setPage(response.data.next_page)
            setLoadingButton(false)
        }
        catch(error){
            //console.log(error)
            toast.error('Ops, algo deu errado !!')
        };
    },[endDate, goals, listBusinessToFilter, page, startDate]);

    useEffect(() => {
        async function loadGoals() {
            setLoading(true)
            setLoadingButton(false)

            try{
                const response = await api.post('/getCompanyGoals/?page=1',
                    {
                        business: listBusinessToFilter,
                        endDate: endDate,
                        startDate: startDate,
                    },
                    {
                        headers: {
                            token: localStorage.getItem('@Inoveclube:token')
                        }
                    }
                )
                setGoals(response.data.goals)
                setPage(response.data.next_page)
            }
            catch(error){
                toast.error('Ops, algo deu errado !!')
            };

            setLoading(false)
        }
        loadGoals();
    }, [listBusinessToFilter, endDate, startDate]);

    async function saveGoal(search, idBusiness, dateGoal, valueGoal, valueBalancePoint) {
        if (idMeta.toString().length > 0) {
            let data = {
                search: search,
                idBusiness: idBusiness,
                dateGoal: dateGoal,
                valueGoal: parseFloat(valueGoal.toString().replace('.', '')),
                valueBalancePoint: parseFloat(valueBalancePoint.toString().replace('.', '')),
                idMeta: idMeta
            }

            await api.put('/updateGoal', {
                data,
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('@Inoveclube:token')
                }
            })
                .then((response) => {
                    // console.log(response)

                    if (response.data.sucess === 0) {
                        toast.error(response.data.error);
                        return;
                    }

                    if (response.data.sucess === 1) {
                        let bus = [];
                        toast.success(response.data.message);

                        listBusinessToFilter.map((item) => {
                            return bus.push(item);
                        })

                        setListBusinessToFilter(bus);
                        dispatch({ type: -1, title: openModalForms.title })
                        return;
                    }

                })
                .catch((error) => {
                    toast.error('Ops, algo deu errado')
                })
            return;
        }

        let data = {
            search: search,
            idBusiness: idBusiness,
            dateGoal: dateGoal,
            valueGoal: parseFloat(valueGoal.toString().replace('.', '')),
            valueBalancePoint: parseFloat(valueBalancePoint.toString().replace('.', '')),
        }
        await api.post('/saveGoal', {
            data,
            headers: {
                'Content-Type': 'application/json',
                token: localStorage.getItem('@Inoveclube:token')
            }
        })
            .then((response) => {
                //console.log(response)

                if (response.data.sucess === 0) {
                    toast.error(response.data.error);
                    return;
                }

                if (response.data.sucess === 1) {
                    let bus = [];
                    toast.success(response.data.message);

                    listBusinessToFilter.map((item) => {
                        return bus.push(item);
                    })

                    setListBusinessToFilter(bus);
                    dispatch({ type: -1, title: openModalForms.title })
                    return;
                }

            })
            .catch((error) => {
                toast.error('Ops, algo deu errado')
            })
    }

    async function deleteGoal(idMeta, idBusiness) {
        let data = {
            idMeta: idMeta
        }
        await api.put('/deleteGoal', {
            data,
            headers: {
                'Content-Type': 'application/json',
                token: localStorage.getItem('@Inoveclube:token')
            }
        })
            .then((response) => {
                if (response.data.sucess === 1) {
                    toast.success(response.data.message);
                }
                else {
                    toast.error(response.data.message)
                }


            })
            .catch((error) => {
                toast.error('Ops, algo deu errado')
            })
    }

    function cancelEdit() {
        setSearch('');
        setDateGoal('');
        setValueGoal('');
        setValueBalancePoint('');
        setIdBusiness('');
        setIdMeta('');
        dispatch({ type: -1, title: openModalForms.title });
    }

    return (
        <MetasContext.Provider
            value={{
                goals,
                setGoals,
                loading,
                setLoading,
                idBusiness,
                search,
                setSearch,
                setIdBusiness,
                dateGoal,
                setDateGoal,
                valueGoal,
                setValueGoal,
                valueBalancePoint,
                setValueBalancePoint,
                idMeta,
                setIdMeta,
                page,
                loadingButton,
                saveGoal,
                deleteGoal,
                cancelEdit,
                handleNewGoals
            }}
        >
            {children}
        </MetasContext.Provider>
    )
}